import { Types } from '@store/types';

import { fetchWorkflowConfiguration } from '@services/crmService';

export const storeCRMOwnConfiguration = () => async (dispatch) => {
	const data = await fetchWorkflowConfiguration();
	dispatch({
		type: Types.SET_CRM_OWN_CONFIGURATION,
		payload: data
	});
};

export const toggleViewQuarterBtn = (data) => async (dispatch) => {
	dispatch({
		type: Types.TOGGLE_CRM_VIEW_QUARTER_BTN,
		payload: data
	});
};

export const toggleTargetMonthView = (data) => async (dispatch) => {
	dispatch({
		type: Types.TOGGLE_CRM_MONTH_VIEW,
		payload: data
	});
};

export const setSelectedTargetFromOutsideOfCRM = (data) => async (dispatch) => {
	dispatch({
		type: Types.IS_REQUEST_COMES_FROM_OUTSIDE_OF_CRM,
		payload: data
	});
};
